
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./pagestyles/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = () => {
    if (!email) {
      setMessage("Please enter your email");
      return;
    }

    // 👉 API call will go here later
    console.log("Reset link sent to:", email);

    setMessage("If this email exists, a reset link has been sent.");
  };

  return (
    <div className="forgot-page">
      <div className="forgot-container">
        <h3 className="forgot-title">Reset your password</h3>

        <p className="forgot-subtext">
          Enter your email and we’ll send you a link to reset your password.
        </p>

        {message && <div className="info-message">{message}</div>}

        <input
          type="email"
          placeholder="Enter your email"
          className="forgot-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button className="reset-btn" onClick={handleReset}>
          Send Reset Link
        </button>

        <div className="forgot-footer">
          <Link to="/signin">Back to Sign in</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;